import 'jquery';

export const getCategoryPageData = (productCategory, country, page, buildingState:any = null) => {
    if (typeof buildingState == "undefined" || buildingState == null || buildingState == ''){
        // @ts-ignore
        buildingState = 0;
    }else{
        // @ts-ignore
        buildingState = buildingState.id;
    }
    if (typeof productCategory == "undefined" || productCategory == null || productCategory == ''){
        productCategory = 0;
    }else{
        productCategory = productCategory.id;
    }
    if (typeof country == "undefined" || country == null || country == ''){
        country = 0;
    }else{
        country = country.id;
    }
    if (typeof page == "undefined" || page == null || page == ''){
        page = 0;
    }else{
        page = page.current_page;
    }
    return $.get(`/ajaxGetReferences?bs=${buildingState}&country=${country}&category=${productCategory}&page=${page}`);
};

